/*
 * Copyright (c) 2021 Mike Vo (info@miketvo.com) - All Rights Reserved.
 *
 * This file is part of the project "miketvo-website".
 *
 * This project is an online personal website by Mike Vo.
 *
 * COPYING AND/OR DISTRIBUTING OF ANY CONTENT WITHIN THIS PROJECT WITHOUT EX-
 * PRESS PERMISSION FROM THE CLIENT AND/OR THE AUTHOR, VIA ANY MEDIUM IS
 * STRICTLY PROHIBITED.
 *
 * Written by Mike Vo on June 27th 2021.
 *
 */

import * as React from "react";

import Layout from "../../components/layout";
import Seo from "../../components/seo";
import SetLang from "../../components/setLang";
import * as headingStyle from "../../styles/heading.module.css";
import * as style from "../styles/contact.module.css";

function validate(ev) {
  if (document.getElementById("reason").value === "0") {
    ev.preventDefault();
    alert("请选择一个联系原因");
  }
}

const ContactPageZH = () => (
  <Layout lang="zh">
    <Seo title="联系方式" lang="zh" />
    <SetLang lang="zh" />
    <div className={style.wrapper}>
      <section className={style.inquiry}>
        <div
          data-sal="slide-right"
          data-sal-duration="1000"
          className={[headingStyle.dash, headingStyle.solidWhite].join(" ")}
        />
        <h1 data-sal="slide-right" data-sal-duration="1000" data-sal-delay="200" className={headingStyle.heading}>
          业务查询
        </h1>
        <p data-sal="slide-right" data-sal-duration="1000" data-sal-delay="400">
          我将在周一至周五的工作日尽快回复、工作时间为格林威治标准时间 7 点 9:00 至 17:00、不包括越南和国际公共假期。
        </p>
        <form
          onSubmit={validate}
          data-sal="slide-right"
          data-sal-duration="1000"
          data-sal-delay="600"
          name="contact-zh"
          action={"/zh/submitted/"}
          method="post"
          data-netlify="true"
          data-netlify-honeypot="bot-field"
          className={style.form}
        >
          <input type="hidden" name="bot-field" />
          <input type="hidden" name="form-name" value="contact-zh" />
          <p className={style.notice}>*强制性</p>
          <div className={style.field}>
            <input type="text" name="name" id="name" required />
            <label htmlFor="name">你的名字</label>
          </div>
          <div className={style.field}>
            <input type="email" name="email" id="email" required />
            <label htmlFor="email">你的邮件</label>
          </div>
          <div className={style.field}>
            <input type="text" name="tel" id="tel" />
            <label htmlFor="tel">您的手机</label>
          </div>
          <div className={[style.field, style.field].join(" ")}>
            <select name="reason" id="reason" required>
              <option value="0" selected>
                选择1
              </option>
              <option value="1">服务包咨询</option>
              <option value="2">个人网站报价</option>
              <option value="3">商业网站报价</option>
              <option value="4">电商平台报价</option>
              <option value="5">技术支持</option>
              <option value="6">反馈</option>
              <option value="7">其他（请在下方说明）</option>
            </select>
            <label htmlFor="reason">联系原因</label>
          </div>
          <div className={style.message}>
            <div className={style.field}>
              <textarea name="message" id="message" rows={5} required />
              <label htmlFor="message">内容</label>
            </div>
          </div>
          <div className={style.buttonBox}>
            <div className={style.field}>
              <button type="reset">
                <div className={style.before} />
                <div className={style.after} />
                <div className={style.content}>
                  <span>复位</span>
                </div>
              </button>
              <button type="submit">
                <div className={style.before} />
                <div className={style.after} />
                <div className={style.content}>
                  <span>提交</span>
                </div>
              </button>
            </div>
          </div>
        </form>
      </section>
      <section className={style.contact}>
        <div
          data-sal="slide-left"
          data-sal-duration="1000"
          data-sal-delay="400"
          className={[headingStyle.dash, headingStyle.solidBlack].join(" ")}
        />
        <h1 data-sal="slide-left" data-sal-duration="1000" data-sal-delay="600" className={headingStyle.heading}>
          联系渠道
        </h1>
        <ul data-sal="slide-left" data-sal-duration="1000" data-sal-delay="800">
          <li className="animated-anchor-black">
            <a href="tel:0385892705">(+84) 385 892 705</a>
          </li>
          <li className="animated-anchor-black">
            <a href="mailto:info@miketvo.com">info@miketvo.com</a>
          </li>
        </ul>
        <ul data-sal="slide-left" data-sal-duration="1000" data-sal-delay="1000" className={style.social}>
          <li>
            <a href={"https://github.com/miketvo"}>
              <span>GitHub</span>
              <img src={"/media/contact_GitHub.svg"} alt="" />
            </a>
          </li>
          <li>
            <a href={"https://twitter.com/ikxplicitie"}>
              <span>Twitter</span>
              <img src={"/media/contact_Twitter.svg"} alt="" />
            </a>
          </li>
          <li>
            <a href={"https://www.instagram.com/ikxplicitie/"}>
              <span>Instagram</span>
              <img src={"/media/contact_Instagram.svg"} alt="" />
            </a>
          </li>
          <li>
            <a href={"https://www.facebook.com/miketvo/"}>
              <span>Facebook</span>
              <img src={"/media/contact_Facebook.svg"} alt="" />
            </a>
          </li>
        </ul>
      </section>
    </div>
  </Layout>
);

export default ContactPageZH;
